import { mount } from '@/mounter'

import SanitasFloorPlan from './SanitasFloorPlan'

const config = window.Sanitas?.floorPlanConfig || {}
mount('floor-plan', SanitasFloorPlan, config)
